import fetchServices from './fetchServices'

export default serviceIds => (dispatch, getState) => {
  dispatch({type: 'set_service_ids', serviceIds})
  dispatch(fetchServices())
}



/** WEBPACK FOOTER **
 ** ./app/actions/setServiceIds.js
 **/